/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrandYcombinator = createSolidComponent(
  "brand-ycombinator",
  "IconBrandYcombinator",
  [
    [
      "path",
      {
        d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
      }
    ],
    ["path", { d: "M8 7l4 6l4 -6" }],
    ["path", { d: "M12 17l0 -4" }]
  ]
);

export { IconBrandYcombinator as default };
//# sourceMappingURL=IconBrandYcombinator.js.map
